/* esm.sh - @radix-ui/react-focus-scope@1.1.8 */
export * from "/*@radix-ui/react-focus-scope@1.1.8/esnext/react-focus-scope.mjs";
